(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-mobile-query.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-mobile-query.js');

'use strict';

const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const useMobileQuery = overrideQuery => {
  const isMobileQuery = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  return typeof overrideQuery === 'boolean' ? overrideQuery : isMobileQuery;
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.hooks.useMobileQuery', useMobileQuery);

 })(window);